import {ChangeDetectionStrategy, Component, computed, DestroyRef, inject, input, model} from "@angular/core"
import {ButtonComponent} from "@common/components/buttons/button/button.component"
import {SliderComponent} from "@common/components/inputs/slider/slider.component"
import {Hotkeys} from "@common/services/hotkeys/hotkeys.service"
import {filter} from "rxjs"
import {BrushSettings} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/brush-strokes/definition"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-brush-settings-panel",
    templateUrl: "./brush-settings-panel.component.html",
    styleUrls: ["./brush-settings-panel.component.scss"],
    imports: [ButtonComponent, SliderComponent],
})
export class BrushSettingsPanelComponent {
    private readonly destroyRef = inject(DestroyRef)
    readonly $brushSettings = model<BrushSettings>(
        {
            color: 1,
            width: 150,
            hardness: 0.8,
        },
        {alias: "brushSettings"},
    )
    readonly $allowBrushModeSelection = input(true, {alias: "allowBrushModeSelection"})
    readonly $disabled = input(false, {alias: "disabled"})
    private readonly hotkeys = inject(Hotkeys)

    constructor() {
        this.hotkeys
            .addShortcut(["+"])
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                filter(() => this.$allowBrushModeSelection()),
            )
            .subscribe(() => this.setBrushMode(BrushMode.Add))
        this.hotkeys
            .addShortcut(["-"])
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                filter(() => this.$allowBrushModeSelection()),
            )
            .subscribe(() => this.setBrushMode(BrushMode.Subtract))
    }

    readonly $brushMode = computed(() => (this.$brushSettings().color === 1 ? BrushMode.Add : BrushMode.Subtract))

    protected setBrushMode(value: BrushMode) {
        this.$brushSettings.update((op) => ({...op, color: value === BrushMode.Add ? 1 : 0}))
    }

    BrushMode = BrushMode
}

enum BrushMode {
    Add = "add",
    Subtract = "subtract",
}
